/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react';
import { Button, ButtonGroup, Dialog, InputText, Loading, SelectCustom } from '@/components';
import { Container, Form, FormGroup } from 'reactstrap';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import TicketIcon from '@/assets/images/svg/Ticket';
import PaymentGateway from '@/model/PaymentGateway';
import DiscountCoupon from '@/model/DiscountCoupon';
import { ActionProps } from '@/components/Dialog';
import { ReactComponent as Pen } from '@/assets/images/svg/pen.svg';
import { CustomTable } from '@/components/Table';
import { X } from 'react-feather';
import BackOnTop from '@/components/sharedComponents/BackOnTop';
import { updateMask as updateMaskCashNumber } from '@/helpers/masks/cashNumber';

import { formPaymentSettingsProps, PaymentSettingsActionsProps } from '../../types';
import { RegisterDiscountCoupon } from '../../components/RegisterDiscountCoupon';
import { columnsDiscountCoupon } from './table';
import { ticketStatesProps } from '../../../SectorTicketGeneralSettingsSreen/types';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

export interface DataRowDiscountCoupon {
  id: string;
  name: string;
  code: string;
  amount: string;
  discount: string;
  actions: string;
}

interface SectorTicketMainSettingsContainerProps {
  state: States;
  enableFee: boolean;
  controllerFormPaymentSettings: formPaymentSettingsProps;
  paymentGatewayList: PaymentGateway[] | undefined;
  title: string | React.ReactNode;
  visible: boolean;
  discountCoupon: DiscountCoupon[];
  listDiscountCoupon: DiscountCoupon[];
  ticketStates: ticketStatesProps;
  handleOnDiscountCoupon: () => Promise<void>;
  handleChangeDiscountCoupon: (name: string, index: number, value: string) => void;
  handleAddDiscountCoupon: () => void;
  onToggle: () => void;
  handleRemoveDiscountCoupon: (index: number) => void;
  onShouldShowModal: ({
    value,
    newTitleModal,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
    event?: Event;
  }) => void;
  shouldShowModal: ShouldShowModal;
  backTab: () => void;
  nextTab: () => void;
  paymentSettingsActions: PaymentSettingsActionsProps;
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  allowSellingWebsite = 'allowSellingWebsite',
  allowSellingPos = 'allowSellingPos',
  allowPaymentCredit = 'allowPaymentCredit',
  creditWebsiteGateway = 'creditWebsiteGateway',
  creditPosGateway = 'creditPosGateway',
  allowPaymentDebit = 'allowPaymentDebit',
  debitWebsiteGateway = 'debitWebsiteGateway',
  debitPosGateway = 'debitPosGateway',
  allowPaymentPIX = 'allowPaymentPIX',
  pixWebsiteGateway = 'pixWebsiteGateway',
  pixPosGateway = 'pixPosGateway',
  allowPaymentBankSlip = 'allowPaymentBankSlip',
  bankslipWebsiteGateway = 'bankslipWebsiteGateway',
  bankslipPosGateway = 'bankslipPosGateway',
  allowFractionalPayment = 'allowFractionalPayment',
  printReceipt = 'printReceipt',
  physicalSaleId = 'physicalSaleId',
  physicalSaleDebit = 'physicalSaleDebit',
  physicalSaleCredit = 'physicalSaleCredit',
  physicalSalePix = 'physicalSalePix',
  physicalSaleAdministrateTax = 'physicalSaleAdministrateTax',
  physicalSaleInstallments = 'physicalSaleInstallments',
  physicalSaleFee = 'physicalSaleFee',
  websiteSaleId = 'websiteSaleId',
  websiteSaleBankSlip = 'websiteSaleBankSlip',
  websiteSaleCredit = 'websiteSaleCredit',
  websiteSalePix = 'websiteSalePix',
  websiteSaleAdministrateTax = 'websiteSaleAdministrateTax',
  websiteSaleInstallments = 'websiteSaleInstallments',
  websiteSaleFee = 'websiteSaleFee',
  allowDiscountCoupon = 'allowDiscountCoupon',
}

// eslint-disable-next-line no-shadow
export enum FormInputNameBatchs {
  name = 'name',
  startDate = 'startDate',
  endDate = 'endDate',
  startTime = 'startTime',
  endTime = 'endTime',
  commission = 'commission',
  amount = 'amount',
  unitValue = 'unitValue',
  totalValue = 'totalValue',
  imageUrl = 'imageUrl',
}

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  discountCoupons = 'discountCoupons',
}

export const SectorTicketPaymentSettingsContainer: React.FC<
  SectorTicketMainSettingsContainerProps
> = ({
  state,
  enableFee,
  controllerFormPaymentSettings,
  paymentGatewayList,
  shouldShowModal,
  title,
  visible,
  discountCoupon,
  listDiscountCoupon,
  ticketStates,
  handleOnDiscountCoupon,
  handleRemoveDiscountCoupon,
  handleChangeDiscountCoupon,
  handleAddDiscountCoupon,
  onToggle,
  onShouldShowModal,
  paymentSettingsActions,
}) => {
  const { formData, formErrors, onChangeFormInput } = controllerFormPaymentSettings;
  const paymentGatewayOptions =
    paymentGatewayList && paymentGatewayList.length > 0
      ? paymentGatewayList.map(item => ({
          label: item.name,
          value: item.id,
        }))
      : [];
  /*
      ? [{ label: '...', value: '' }].push(
          ,
        )
      : [] */
  const renderActionDialogToCancelDiscountCoupon: ActionProps = {
    title: 'Cancelar',
    onClick: (): void => onToggle(),
    theme: 'noneBorder',
  };

  const optionCount = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },
    { label: '17', value: '17' },
    { label: '18', value: '18' },
    { label: '19', value: '19' },
    { label: '20', value: '20' },
    { label: '21', value: '21' },
    { label: '22', value: '22' },
    { label: '23', value: '23' },
    { label: '24', value: '24' },
  ];

  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <Dialog
        title={title}
        visible={visible}
        onClose={onToggle}
        actions={[
          {
            [ShouldShowModal.discountCoupons]: renderActionDialogToCancelDiscountCoupon,
          }[shouldShowModal],
          {
            [ShouldShowModal.discountCoupons]: {
              title: 'Adicionar cupons',
              onClick: () => {
                handleOnDiscountCoupon();
              },
            },
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.discountCoupons]: (
              <RegisterDiscountCoupon
                handleRemoveDiscountCoupon={handleRemoveDiscountCoupon}
                handleAddDiscountCoupon={handleAddDiscountCoupon}
                discountCoupon={discountCoupon}
                handleChangeDiscountCoupon={handleChangeDiscountCoupon}
              />
            ),
          }[shouldShowModal]
        }
      </Dialog>
      <Container className="mainContainer" fluid={true}>
        <div className="container-event">
          <Form
            noValidate={true}
            onSubmit={(e): void => {
              e.preventDefault();
            }}
          >
            <FormGroup className="mb-2">
              <ButtonGroup
                label="Permitir vender online?"
                name="allowSellingWebsite"
                value={formData[FormInputName.allowSellingWebsite]}
                onChange={e => onChangeFormInput(FormInputName.allowSellingWebsite)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowSellingWebsite && formErrors.allowSellingWebsite[0]}
              />
              <ButtonGroup
                label="Permitir vender na POS?"
                name="allowSellingPos"
                value={formData[FormInputName.allowSellingPos]}
                onChange={e => onChangeFormInput(FormInputName.allowSellingPos)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowSellingPos && formErrors.allowSellingPos[0]}
              />
              <ButtonGroup
                label="Permitir pagamento com crédito?"
                name="allowPaymentCredit"
                value={formData[FormInputName.allowPaymentCredit]}
                onChange={e => onChangeFormInput(FormInputName.allowPaymentCredit)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowPaymentCredit && formErrors.allowPaymentCredit[0]}
              />
              {formData[FormInputName.allowPaymentCredit] === 'true' && (
                <div className="d-flex">
                  <SelectCustom
                    name="creditWebsiteGateway"
                    label="Gateway On-Line"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingWebsite] === 'true'
                        ? formData[FormInputName.creditWebsiteGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.creditWebsiteGateway)(e?.value as string)
                    }
                    error={formErrors.creditWebsiteGateway && formErrors.creditWebsiteGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingWebsite] !== 'true'}
                  />
                  <span style={{ width: '40px' }} />
                  <SelectCustom
                    name="creditPosGateway"
                    label="Gateway Fisica"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingPos] === 'true'
                        ? formData[FormInputName.creditPosGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.creditPosGateway)(e?.value as string)
                    }
                    error={formErrors.creditPosGateway && formErrors.creditPosGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingPos] !== 'true'}
                  />
                </div>
              )}
              <ButtonGroup
                label="Permitir pagamento com débito?"
                name="allowPaymentDebit"
                value={formData[FormInputName.allowPaymentDebit]}
                onChange={e => onChangeFormInput(FormInputName.allowPaymentDebit)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowPaymentDebit && formErrors.allowPaymentDebit[0]}
              />
              {formData[FormInputName.allowPaymentDebit] === 'true' && (
                <div className="d-flex">
                  <SelectCustom
                    name="debitWebsiteGateway"
                    label="Gateway On-Line"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingWebsite] === 'true'
                        ? formData[FormInputName.debitWebsiteGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.debitWebsiteGateway)(e?.value as string)
                    }
                    error={formErrors.debitWebsiteGateway && formErrors.debitWebsiteGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingWebsite] !== 'true'}
                  />
                  <span style={{ width: '40px' }} />
                  <SelectCustom
                    name="debitPosGateway"
                    label="Gateway Fisica"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingPos] === 'true'
                        ? formData[FormInputName.debitPosGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.debitPosGateway)(e?.value as string)
                    }
                    error={formErrors.debitPosGateway && formErrors.debitPosGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingPos] !== 'true'}
                  />
                </div>
              )}
              <ButtonGroup
                label="Permitir pagamento com PIX?"
                name="allowPaymentPIX"
                value={formData[FormInputName.allowPaymentPIX]}
                onChange={e => onChangeFormInput(FormInputName.allowPaymentPIX)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowPaymentPIX && formErrors.allowPaymentPIX[0]}
              />
              {formData[FormInputName.allowPaymentPIX] === 'true' && (
                <div className="d-flex">
                  <SelectCustom
                    name="pixWebsiteGateway"
                    label="Gateway On-Line"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingWebsite] === 'true'
                        ? formData[FormInputName.pixWebsiteGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.pixWebsiteGateway)(e?.value as string)
                    }
                    error={formErrors.pixWebsiteGateway && formErrors.pixWebsiteGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingWebsite] !== 'true'}
                  />
                  <span style={{ width: '40px' }} />
                  <SelectCustom
                    name="pixPosGateway"
                    label="Gateway Fisica"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingPos] === 'true'
                        ? formData[FormInputName.pixPosGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.pixPosGateway)(e?.value as string)
                    }
                    error={formErrors.pixPosGateway && formErrors.pixPosGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingPos] !== 'true'}
                  />
                </div>
              )}
              <ButtonGroup
                label="Permitir pagamento com Boleto?"
                name="allowPaymentBankSlip"
                value={formData[FormInputName.allowPaymentBankSlip]}
                onChange={e =>
                  onChangeFormInput(FormInputName.allowPaymentBankSlip)(e.target.value)
                }
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowPaymentBankSlip && formErrors.allowPaymentBankSlip[0]}
              />
              {formData[FormInputName.allowPaymentBankSlip] === 'true' && (
                <div className="d-flex">
                  <SelectCustom
                    name="bankslipWebsiteGateway"
                    label="Gateway On-Line"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingWebsite] === 'true'
                        ? formData[FormInputName.bankslipWebsiteGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.bankslipWebsiteGateway)(e?.value as string)
                    }
                    error={
                      formErrors.bankslipWebsiteGateway && formErrors.bankslipWebsiteGateway[0]
                    }
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingWebsite] !== 'true'}
                  />
                  <span style={{ width: '40px' }} />
                  <SelectCustom
                    name="bankslipPosGateway"
                    label="Gateway Fisica"
                    placeholder="Selecione o Gateway"
                    className="w-input-lg"
                    value={
                      formData[FormInputName.allowSellingPos] === 'true'
                        ? formData[FormInputName.bankslipPosGateway]
                        : ''
                    }
                    onChange={e =>
                      onChangeFormInput(FormInputName.bankslipPosGateway)(e?.value as string)
                    }
                    error={formErrors.bankslipPosGateway && formErrors.bankslipPosGateway[0]}
                    options={paymentGatewayOptions}
                    disabled={formData[FormInputName.allowSellingPos] !== 'true'}
                  />
                </div>
              )}
              <ButtonGroup
                label="Permitir pagamento fracionado?"
                name="allowFractionalPayment"
                value={formData[FormInputName.allowFractionalPayment]}
                onChange={e =>
                  onChangeFormInput(FormInputName.allowFractionalPayment)(e.target.value)
                }
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.allowFractionalPayment && formErrors.allowFractionalPayment[0]}
              />

              <ButtonGroup
                label="Imprimir recibo (POS)?"
                name="printReceipt"
                value={formData[FormInputName.printReceipt]}
                onChange={e => onChangeFormInput(FormInputName.printReceipt)(e.target.value)}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                error={formErrors.printReceipt && formErrors.printReceipt[0]}
              />
            </FormGroup>
          </Form>
        </div>

        <div className="container-event mb-4">
          {enableFee && (
            <Fragment>
              <h5 className="mb-2 border-bottom-title mb-5">Taxas de cartão</h5>

              <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda física</p>

              <FormGroup>
                <InputText
                  name="physicalSaleDebit"
                  label="Débito"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.physicalSaleDebit]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.physicalSaleDebit)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.physicalSaleDebit && formErrors.physicalSaleDebit[0]}
                />
                <InputText
                  name="physicalSaleCredit"
                  label="Crédito"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.physicalSaleCredit]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.physicalSaleCredit)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.physicalSaleCredit && formErrors.physicalSaleCredit[0]}
                />
                <InputText
                  name="physicalSalePix"
                  label="PIX"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.physicalSalePix]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.physicalSalePix)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.physicalSalePix && formErrors.physicalSalePix[0]}
                />
                <InputText
                  name="physicalSaleAdministrateTax"
                  label="Taxa administrativa"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.physicalSaleAdministrateTax]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.physicalSaleAdministrateTax)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={
                    formErrors.physicalSaleAdministrateTax &&
                    formErrors.physicalSaleAdministrateTax[0]
                  }
                />
              </FormGroup>
              <div className="d-flex">
                <SelectCustom
                  name="physicalSaleInstallments"
                  label="Qtd parcelas"
                  placeholder="Ex: 2"
                  className="w-input-sm"
                  value={formData[FormInputName.physicalSaleInstallments]}
                  onChange={e =>
                    onChangeFormInput(FormInputName.physicalSaleInstallments)(e?.value as string)
                  }
                  error={
                    formErrors.physicalSaleInstallments && formErrors.physicalSaleInstallments[0]
                  }
                  options={optionCount}
                />
                <span className="mt-5 mr-3 ml-3 input-label"> + </span>
                <InputText
                  name="physicalSaleFee"
                  label="Juros ao mês"
                  className="w-input-sm"
                  addon="%"
                  placeholder="Ex: 4"
                  maxLength={5}
                  value={formData[FormInputName.physicalSaleFee]}
                  onChange={e =>
                    onChangeFormInput(FormInputName.physicalSaleFee)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.physicalSaleFee && formErrors.physicalSaleFee[0]}
                />
              </div>

              <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda e-commerce</p>

              <FormGroup>
                <InputText
                  name="websiteSaleBankSlip"
                  label="Boleto"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.websiteSaleBankSlip]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.websiteSaleBankSlip)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.websiteSaleBankSlip && formErrors.websiteSaleBankSlip[0]}
                />
                <InputText
                  name="websiteSaleCredit"
                  label="Crédito"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.websiteSaleCredit]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.websiteSaleCredit)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.websiteSaleCredit && formErrors.websiteSaleCredit[0]}
                />
                <InputText
                  name="websiteSalePix"
                  label="PIX"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.websiteSalePix]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.websiteSalePix)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.websiteSalePix && formErrors.websiteSalePix[0]}
                />
                <InputText
                  name="websiteSaleAdministrateTax"
                  label="Taxa administrativa"
                  className="w-input-sm"
                  addon="%"
                  maxLength={5}
                  value={formData[FormInputName.websiteSaleAdministrateTax]}
                  placeholder="Ex: 1"
                  onChange={e =>
                    onChangeFormInput(FormInputName.websiteSaleAdministrateTax)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={
                    formErrors.websiteSaleAdministrateTax &&
                    formErrors.websiteSaleAdministrateTax[0]
                  }
                />
              </FormGroup>
              <div className="d-flex">
                <SelectCustom
                  name="websiteSaleInstallments"
                  label="Qtd parcelas"
                  placeholder="Ex: 2"
                  className="w-input-sm"
                  value={formData[FormInputName.websiteSaleInstallments]}
                  onChange={e =>
                    onChangeFormInput(FormInputName.websiteSaleInstallments)(e?.value as string)
                  }
                  error={
                    formErrors.websiteSaleInstallments && formErrors.websiteSaleInstallments[0]
                  }
                  options={optionCount}
                />
                <span className="mt-5 mr-3 ml-3 input-label"> + </span>
                <InputText
                  name="websiteSaleFee"
                  label="Juros ao mês"
                  className="w-input-sm"
                  addon="%"
                  placeholder="Ex: 4"
                  maxLength={5}
                  value={formData[FormInputName.websiteSaleFee]}
                  onChange={e =>
                    onChangeFormInput(FormInputName.websiteSaleFee)(
                      updateMaskCashNumber(e.target.value),
                    )
                  }
                  error={formErrors.websiteSaleFee && formErrors.websiteSaleFee[0]}
                />
              </div>
            </Fragment>
          )}

          <div className="container-event mb-4">
            <h5 className="mb-2 border-bottom-title mb-5">Cupons e descontos</h5>
          </div>

          <FormGroup>
            {/* 
            <ButtonGroup
              label="Permitir desconto?"
              name="allowDiscount"
              value={formData[FormInputName.allowDiscount]}
              onChange={e => onChangeFormInput(FormInputName.allowDiscount)(e.target.value)}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
              error={formErrors.allowDiscount && formErrors.allowDiscount[0]}
            />
            */}
            <ButtonGroup
              label="Permitir cupom de desconto?"
              name="allowDiscountCoupon"
              value={formData[FormInputName.allowDiscountCoupon]}
              onChange={e => onChangeFormInput(FormInputName.allowDiscountCoupon)(e.target.value)}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
              error={formErrors.allowDiscountCoupon && formErrors.allowDiscountCoupon[0]}
            />
          </FormGroup>
        </div>

        {formData[FormInputName.allowDiscountCoupon] === 'true' ? (
          <div
            onClick={() =>
              onShouldShowModal({
                newTitleModal: 'Adicionar cupom de desconto',
                value: ShouldShowModal.discountCoupons,
              })
            }
            className="action-icon mb-5 register-buttom"
          >
            + adicionar cupom de desconto
          </div>
        ) : null}

        <SuperCollapse
          title={`Cupons de desconto adicionados`}
          content={
            listDiscountCoupon.length > 0 ? (
              listDiscountCoupon.map((item, index) => (
                <>
                  <span className="secondary-table-title">Cupom #{index + 1}</span>
                  <span className="secondary-table-title name">
                    <b> ·</b> {item.name}
                  </span>
                  <CustomTable
                    numberRowsPerPage={0}
                    progressPending={false}
                    columns={columnsDiscountCoupon}
                    data={[
                      {
                        id: item.id,
                        name: item.name,
                        code: item.code,
                        amount: item.amount,
                        discount: `${item.discount || 0} %`,
                        actions: (
                          <React.Fragment>
                            <Pen
                              className="mr-4 svg-icon action-icon"
                              onClick={(): void =>
                                onShouldShowModal({
                                  value: ShouldShowModal.discountCoupons,
                                  newTitleModal: (
                                    <div className="d-flex">
                                      <div
                                        className="m-auto"
                                        onClick={() => {
                                          onShouldShowModal({
                                            value: ShouldShowModal.discountCoupons,
                                            newTitleModal: discountCoupon?.length
                                              ? item.name
                                              : 'Cadastrar nova empresa (contratante)',
                                          });
                                        }}
                                      ></div>
                                      <h5 className="header-title-text modal__title ml-3 mb-0">
                                        Adicionar conta bancária
                                      </h5>
                                    </div>
                                  ),
                                })
                              }
                            />
                            <X
                              className="svg-icon action-icon pt-1"
                              onClick={() => {
                                handleRemoveDiscountCoupon(index);
                              }}
                            />
                          </React.Fragment>
                        ),
                      },
                    ]}
                    theme="secondary"
                  />
                </>
              ))
            ) : (
              <span>Nenhum cupom de desconto adicionado</span>
            )
          }
          count={listDiscountCoupon.length}
          leftIcon={TicketIcon()}
        />

        <div className="d-flex justify-content-end">
          {/* <div>
            <Button
              title="Salvar"
              theme="noneBorder"
              onClick={async () => {
                await paymentSettingsActions.onSave();
              }}
            />
          </div> */}
          <div className="d-flex">
            <div className="m-2 mr-5">
              <BackOnTop />
            </div>
            <Button
              title="Voltar etapa"
              theme="noneBorder"
              onClick={() => {
                paymentSettingsActions.onReturnTab();
              }}
            />
            <Button
              title={ticketStates.ticket ? 'Salvar e avançar' : 'Próxima etapa'}
              theme="outlineDark"
              className="ml-3"
              onClick={async () => {
                await paymentSettingsActions.onNextTap();
              }}
            />
          </div>
        </div>
      </Container>
    </Fragment>
  );
};
